<template>
  <div class="font-logo font-bold">Cicada</div>
</template>
